import * as React from 'react';
import CollapsibleSidebar from '../collapsible-sidebar/collapsible-sidebar';
import TeamDropdown from '../team-dropdown/team-dropdown';
import Menu from './menu';
import * as styles from './layout.module.scss';
import { CircularProgress } from '@material-ui/core';
import { AppContext, AppProviderDispatch } from '../../shared/app-context';
import { useClients } from '../../hooks/useClients';

/**
 * LeftToolbar
 * @function LeftToolbar - Displays the left toolbar on the main page
 */
const LeftToolbar = () => {
  const appContext = React.useContext<AppProviderDispatch>(AppContext);
  const clientsQuery = useClients();
  const [collapsed, setCollapsed] = React.useState(localStorage.getItem('sidebarCollapsed') === 'true');

  React.useEffect(() => {
    localStorage.setItem('sidebarCollapsed', String(collapsed));
  }, [collapsed]);

  return (
    <CollapsibleSidebar
      initialCollapse={collapsed}
      collapsedClass={styles.collapsed}
      sidebarClass={styles.sidebar}
      onCollapseToggle={(collapseState: boolean) => setCollapsed(collapseState)}
    >
      {clientsQuery.isLoading ? (
        <div className={styles.menuLoading}>
          <CircularProgress size="20px" color="inherit" />
        </div>
      ) : (
        <React.Fragment>
          <TeamDropdown clientId={appContext.state.clientId} collapsed={collapsed} />
          <Menu collapsed={collapsed} />
        </React.Fragment>
      )}
    </CollapsibleSidebar>
  );
};

export default LeftToolbar;
